<!--学习培训-->
<template>
  <div class="trainingPage">

    <div class="banner">
      <div class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index" @click="onBanner(item)">
            <img style="width: 100%"
                 :src="item.imgUrl"/>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
        </div>

      </div>
    </div>

    <div class="training">
      <div class="tab-btn">
        <el-radio-group v-model="tabPosition" style="margin-bottom: 24px;" @change="tabChange">
          <el-radio-button class="training-tab" v-for="(item, index) in tabs" :key="index" :label="item.typeId">{{
              item.name
            }}
          </el-radio-button>
        </el-radio-group>
      </div>

      <el-row :gutter="20">
        <el-col class="training-col" style="position: relative;" :span="8" v-for="(item, index) in list" :key="index">
          <div class="training-content"
               @mouseover="mouseOverTrain(index)"
               @mouseleave="mouseLeaveTrain(index)"
               @click="toInfo(item.id)">
            <img class="training-content-img" style="width: 100%;height: 220px"
                 :src="item.imgUrl"/>

            <div class="training-content-info">
              <div class="card-title">{{ item.name }}</div>
              <div style="display: flex;margin-top: 5px">
                <div style="color: #999999FF;width: 50%"><i class="el-icon-time"></i> 总时长 {{
                    item.totalDuration
                  }}
                </div>
                <div style="color: #999999FF;width: 50%;text-align: right"><i class="el-icon-user"></i>
                  {{ item.studyCount }}人已学习
                </div>
              </div>
            </div>
          </div>

          <img v-if="item.excellentFlag == 1"
               style="position: absolute; top: 0px; width: 60px; height: 22px"
               src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/train/tag_jingxuan@2x.png">

          <div
            class="train-preview"
            v-show="item.show"
            @mouseover="mouseOverTrain(index)"
            @mouseleave="mouseLeaveTrain(index)">
            <div class="training-content"
                 @mouseover="mouseOverTrain(index)"
                 @mouseleave="mouseLeaveTrain(index)"
                 @click="toInfo(item.id)">
              <video :id="item.show ? 'trainVideo' : ''" class="swiper-content-img" muted
                     style="width: 100%;height: 214px;max-width: 400px; border-radius: 6px 6px 0 0;margin-top: 20px"
                     :src="item.videoUrl"/>

              <div class="training-content-info">
                <div class="card-title">{{ item.name }}</div>
                <div style="display: flex;margin-top: 5px">
                  <div style="color: #999999FF;width: 50%"><i class="el-icon-time"></i> 总时长 {{
                      item.totalDuration
                    }}
                  </div>
                  <div style="color: #999999FF;width: 50%;text-align: right"><i class="el-icon-user"></i>
                    {{ item.studyCount }}人已学习
                  </div>
                </div>
              </div>
            </div>
          </div>

        </el-col>
      </el-row>

    </div>

    <div v-show="total>pageSize" style="width: 100%; text-align: center; padding-top: 50px">

      <el-pagination
        :page-size="pageSize"
        layout="prev, pager, next"
        :current-page.sync="pageNum"
        @current-change="handleCurrentChange"
        :total="total">
      </el-pagination>

    </div>

  </div>
</template>

<script>
import {trainArea, trainCourse, trainBanner} from '@api/train'
import Swiper from 'swiper'

export default {
  name: 'training',
  components: {},
  data() {
    return {
      tabPosition: undefined,
      total: 0,
      pageNum: 1,
      pageSize: 15,
      tabs: [],
      list: [],
      bannerList: [{imgUrl: 'http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/banner/peixun_banner@2x%20(1).png'}]
    }
  },
  created() {
    this.getTrainArea()
    // this.getTrainBanner()
  },
  mounted() {
    // new Swiper('.swiper', {
    //   loop: 1 === 1,
    //   // 如果需要分页器
    //   pagination: '.swiper-pagination',
    //   autoplay: 1 === 1 ? 3000 : false,
    // })
  },
  methods: {

    // 学习培训移入
    mouseOverTrain(index) {
      this.list[index].show = true
      this.$forceUpdate()

      let video = document.querySelector('#trainVideo')
      if (video) {
        video.play()
      }
    },

    // 学习培训移出
    mouseLeaveTrain(index) {
      this.list[index].show = false
      this.$forceUpdate()

      let video = document.querySelector('#trainVideo')
      if (video) {
        video.pause()
      }
    },

    // banner 点击
    onBanner() {
    },

    // 获取banner
    getTrainBanner() {
      trainBanner().then(res => {
        if (res.data.code === 200) {
          this.bannerList = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // tab切换
    tabChange(e) {
      this.pageNum = 1
      this.tabPosition = e
      this.getTrainList()
    },

    // 分页切换
    handleCurrentChange(e) {
      this.pageNum = e
      this.getTrainList()
    },

    // 获取功能区数据
    getTrainArea() {
      trainArea().then(res => {
        if (res.data.code === 200) {
          this.tabs = res.data.data
          if (this.tabs.length > 0) {
            this.tabPosition = res.data.data[0].typeId
            this.getTrainList()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // 获取列表数据
    getTrainList() {
      var params = {
        typeId: this.tabPosition,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.loadingGoods = true
      trainCourse(params).then(res => {
        if (res.data.code === 200) {
          this.loadingGoods = false
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.ifHasProduct = true
            this.list = res.data.data.rows
            this.total = res.data.data.totalRows
          } else {
            this.ifHasProduct = false
          }
          // 滚动到顶部
          window.scrollTo({
            'top': 0,
            'behavior': 'smooth'
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // 获取详情
    toInfo(id) {
      this.enterRouter('trainingInfo', {courseId: id})
    },
  }
}
</script>

<style scoped lang="scss">

.trainingPage {
  margin-bottom: 50px;

  .train-preview {
    border-radius: 6px;
    position: absolute;
    width: 400px;
    height: 290px;
    background-color: #37a0ff;
    top: -12px;
    left: 0px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.18);
  }

  .tab-btn {
    padding-top: 20px;
  }

  .card-title {
    font-size: 18px;
    font-weight: bold;
    display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .swiper {
    height: auto;
    width: 100%;
    overflow: hidden;

    .swiper-wrapper {
      .swiper-slide {
        width: 100% !important;
        height: 100%;

        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .el-pager li {
    background: #f9f9f9 !important;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .el-pager li.active {
    background-color: #096CEFFF !important;
    color: #FFFFFF;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .el-pagination .btn-next {
    background: center center no-repeat #f9f9f9;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .el-pagination .btn-prev {
    background: center center no-repeat #f9f9f9;
  }

  .training-tab {
    margin: 0 10px;
    border-radius: 5px;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .el-radio-button__inner {
    border: 0 !important;
    background: bottom !important;
    font-size: 16px !important;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .is-active .el-radio-button__inner {
    border-radius: 5px !important;
    background: #096CEFFF !important;
  }

  .training-col {
    margin-bottom: 20px;
  }

  .training-content {
    background: #fff;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);

    .training-content-img {
      width: 100%;
      height: 220px;
      border-radius: 5px 5px 0 0;
    }

    .training-content-info {
      background: #fff;
      padding: 10px 15px 20px 15px;
      border-radius: 5px;
    }
  }

  .training-content:hover {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.28);

    .training-content-info {
      color: #37a0ff;
    }
  }

  .trainingPage {
    margin-bottom: 60px;
    width: 100%;
  }

  .training {
    margin: auto;
    width: 1200px;
  }
}
</style>
